import { Play, Clock, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export const ContentCard = ({ content }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      whileHover={{ scale: 1.03 }}
      className="group relative overflow-hidden rounded-xl bg-card border border-border hover:border-primary/50 cursor-pointer glow-on-hover"
      onClick={() => navigate(`/watch/${content.id}`)}
      data-testid={`content-card-${content.id}`}
    >
      {/* Thumbnail */}
      <div className="relative aspect-video overflow-hidden">
        <img
          src={content.thumbnail_url}
          alt={content.title}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-4 left-4 right-4">
            <div className="flex items-center space-x-2">
              <Play className="w-8 h-8 text-primary" fill="currentColor" />
              <span className="text-white font-bold">Watch Now</span>
            </div>
          </div>
        </div>

        {/* Live badge */}
        {content.is_live && (
          <div className="absolute top-3 right-3 flex items-center space-x-1 bg-secondary px-3 py-1 rounded-full" data-testid={`live-badge-${content.id}`}>
            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <span className="text-white text-xs font-bold uppercase">Live</span>
          </div>
        )}

        {/* Premium badge */}
        {content.is_premium && !content.is_live && (
          <div className="absolute top-3 right-3 bg-primary px-3 py-1 rounded-full" data-testid={`premium-badge-${content.id}`}>
            <span className="text-black text-xs font-bold uppercase">Premium</span>
          </div>
        )}
      </div>

      {/* Content info */}
      <div className="p-4">
        <h3 className="font-bold text-white text-lg line-clamp-2 mb-2" data-testid={`content-title-${content.id}`}>
          {content.title}
        </h3>
        <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
          {content.description}
        </p>
        
        {/* Meta info */}
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <div className="flex items-center space-x-3">
            {content.league && (
              <span className="px-2 py-1 bg-accent/20 text-accent rounded">
                {content.league}
              </span>
            )}
            {content.views > 0 && (
              <div className="flex items-center space-x-1">
                <Eye className="w-3 h-3" />
                <span>{content.views.toLocaleString()}</span>
              </div>
            )}
          </div>
          {content.ppv_price && (
            <span className="text-primary font-bold">${content.ppv_price}</span>
          )}
        </div>
      </div>
    </motion.div>
  );
};